<template>
    <router-link :to="{ name: 'AcademySingle', params: { slug: slug }}">
        <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
            <ion-card v-if="show" mode="ios" class="ion-activatable" :style="{ backgroundImage: 'url(' + image + ')' }">
                <ion-card-content>
                    <ion-label mode="md">
                        <h2 v-if="name" style="color: #000">{{ name }}</h2>
                        <p v-if="city">Miasto: <strong>{{ city }}</strong></p>
                        <p v-if="title">{{ title }}</p>
                    </ion-label>
                </ion-card-content>
            </ion-card>
        </slide-x-left-transition>
    </router-link>
</template>

<script>
    export default {
        name: 'ItemAcademy',
        props: ['index', 'slug', 'name', 'title' , 'academy_name', 'city', 'date_meeting', 'image'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
    }
</script>

<style lang="scss" scoped>
    ion-card{
        margin: 0 0 20px 0px;
        text-align: center;
        background-size: cover;
    }
    ion-card-content{
        position: relative;
        height: 150px;
        padding: 20px 15px;
        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6306723372942927) 75%);
        ion-label{
            position: absolute;
            left: 0;
            bottom: 20px;
            width: 100%;
            h1,h2,h3,p,span{
                color: white !important;
            }
        }
    }
</style>